"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AddEndpointPosts {
    constructor(container, map, markers) {
        this.container = container;
        this.postsContainer = null;
        this.postsContainer = this.container.querySelector('[data-js-osm-endpoint-posts]');
        if (this.postsContainer) {
            this.listenForPostsFetched();
        }
    }
    listenForPostsFetched() {
        this.container.addEventListener('postsFetched', (e) => {
            const customEvent = e;
            if (customEvent.detail && customEvent.detail.length > 0) {
                customEvent.detail.forEach((elementString) => {
                    if (elementString.includes('data-js-map-location=""'))
                        return;
                    this.addPostsToDOM(elementString);
                });
            }
        });
    }
    addPostsToDOM(elementString) {
        let post = document.createElement('div');
        post.classList.add('c-openstreetmap__posts');
        post.innerHTML = elementString;
        post = post.firstChild;
        this.postsContainer.appendChild(post);
        this.dispatchPostAddedEvent(post);
    }
    dispatchPostAddedEvent(post) {
        this.container.dispatchEvent(new CustomEvent('postAdded', { detail: post }));
    }
}
exports.default = AddEndpointPosts;
